export default "__VITE_ASSET__16d2dad2__"